"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const FormLinkedTable = props => {
  const {
    columns,
    data
  } = props.results;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-12 align-bottom col-sm-".concat(props.divColSize)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container p-0"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("label", {
    className: (0, _classnames.default)("col-sm-12 m-0 pt-2 pb-2")
  }, props.label), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-12"
  }, /*#__PURE__*/_react.default.createElement("table", {
    className: "table table-sm table-striped"
  }, /*#__PURE__*/_react.default.createElement("thead", {
    className: "thead-dark"
  }, /*#__PURE__*/_react.default.createElement("tr", null, columns.map((column, i) => {
    return /*#__PURE__*/_react.default.createElement("th", {
      key: "headerRow".concat(i)
    }, column.displayName);
  }))), /*#__PURE__*/_react.default.createElement("tbody", null, data.map((data, i) => {
    return /*#__PURE__*/_react.default.createElement("tr", {
      key: "dataRow".concat(i)
    }, columns.map((column, e) => {
      return /*#__PURE__*/_react.default.createElement("td", {
        key: "data_".concat(i, "_").concat(e)
      }, data[column.fieldName]);
    }));
  })))))));
};
var _default = FormLinkedTable;
exports.default = _default;